/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type LineRichMenuStatus =
  | 'PUBLISHED'
  | 'UNPUBLISHED';

export type LineRichMenuIndexPageQueryVariables = Exact<{ [key: string]: never; }>;


export type LineRichMenuIndexPageQuery = { lineRichMenus: { lineRichMenus: Array<{ guid: string, label: string, status: Types.LineRichMenuStatus }> } };

export type DeleteLineRichMenuMutationVariables = Exact<{
  input: string | number;
}>;


export type DeleteLineRichMenuMutation = { deleteLineRichMenu: { void: any } };


export const LineRichMenuIndexPageDocument = gql`
    query LineRichMenuIndexPage {
  lineRichMenus {
    lineRichMenus {
      guid
      label
      status
    }
  }
}
    `;

/**
 * __useLineRichMenuIndexPageQuery__
 *
 * To run a query within a Vue component, call `useLineRichMenuIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useLineRichMenuIndexPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLineRichMenuIndexPageQuery();
 */
export function useLineRichMenuIndexPageQuery(options: VueApolloComposable.UseQueryOptions<LineRichMenuIndexPageQuery, LineRichMenuIndexPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineRichMenuIndexPageQuery, LineRichMenuIndexPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineRichMenuIndexPageQuery, LineRichMenuIndexPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LineRichMenuIndexPageQuery, LineRichMenuIndexPageQueryVariables>(LineRichMenuIndexPageDocument, {}, options);
}
export function useLineRichMenuIndexPageLazyQuery(options: VueApolloComposable.UseQueryOptions<LineRichMenuIndexPageQuery, LineRichMenuIndexPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LineRichMenuIndexPageQuery, LineRichMenuIndexPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LineRichMenuIndexPageQuery, LineRichMenuIndexPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LineRichMenuIndexPageQuery, LineRichMenuIndexPageQueryVariables>(LineRichMenuIndexPageDocument, {}, options);
}
export type LineRichMenuIndexPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LineRichMenuIndexPageQuery, LineRichMenuIndexPageQueryVariables>;
export const DeleteLineRichMenuDocument = gql`
    mutation DeleteLineRichMenu($input: ID!) {
  deleteLineRichMenu(guid: $input) {
    void
  }
}
    `;

/**
 * __useDeleteLineRichMenuMutation__
 *
 * To run a mutation, you first call `useDeleteLineRichMenuMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLineRichMenuMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteLineRichMenuMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLineRichMenuMutation(options: VueApolloComposable.UseMutationOptions<DeleteLineRichMenuMutation, DeleteLineRichMenuMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteLineRichMenuMutation, DeleteLineRichMenuMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteLineRichMenuMutation, DeleteLineRichMenuMutationVariables>(DeleteLineRichMenuDocument, options);
}
export type DeleteLineRichMenuMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteLineRichMenuMutation, DeleteLineRichMenuMutationVariables>;